export const reportData = {
  email: 'olexandra.saverina@lasoft.org',
  name: 'Front End Test',
  page_id: 'CRZ0eIq_D2n5n_xITRt-g',
  description: '',
  type_id: '6952567bc879ac4c2f1501b0',
  stage: ['upgrade'],
  domain_id: '6952567cc879ac4c2f1501b8',
  domain_other: null,
  modules: [
    '695f8587b2ede795259fc030',
    '695f8588b2ede795259fc05c',
    '695f8587b2ede795259fc02f',
    '695f8587b2ede795259fc029',
    '695f8587b2ede795259fc037',
    '695f8587b2ede795259fc031',
    '695f8587b2ede795259fc03a',
    '695f8588b2ede795259fc05e',
  ],
  time_period: '24+ months',
  budget: '€160K+',
  have_design: false,
  file: null,
  created_at: '2026-07-06T08:52:33.743000',
  updated_at: '2026-07-06T08:52:33.743000',
  _id: '6a4b6cd14e659285f75e1e34',
  modules_names: [
    'Subscriptions & Billing',
    'Campaign Management',
    'Product Catalog & Inventory',
    'Admin Dashboard & CMS (Back office)',
    'Orders & Fulfillment',
    'Payments',
    'Reviews & Ratings',
    '3rd party integration',
  ],
  domain_name: 'Marketing',
  type_name: 'Marketplace',
  results: {
    fastest: {
      hours: 820,
      price_min: 28700.0,
      price_max: 33005.0,
      discovery: 2.4,
      design_min: 11242.0,
      design_max: 12928.5,
      accuracy: 75.0,
      people_in_team: 3,
      weeks_min: 10,
      weeks_max: 12,
      team: [
        {
          name: 'Project Manager (part-time)',
          amount: 1,
        },
        {
          name: 'Full-stack Developer',
          amount: 1,
        },
        {
          name: 'QA Engineer (part-time)',
          amount: 1,
        },
        {
          name: 'UI/UX Designer',
          amount: 1,
        },
      ],
      consultation_minutes: 45,
      system_discovery_days_min: 10,
      system_discovery_days_max: 15,
      design_days_min: 40,
      design_days_max: 48,
      system_development_days_min: 51,
      system_development_days_max: 61,
      system_improvement_days_min: 10,
      system_improvement_days_max: 21,
      key_features: {
        feature_1:
          'Automated billing and subscription management for seamless recurring payments.',
        feature_2:
          'Tools for creating, managing, and analyzing marketing campaigns across multiple channels.',
        feature_3:
          'Comprehensive product catalog with inventory tracking, enabling real-time updates.',
        feature_4:
          'User-friendly admin dashboard for easy access to analytics and content management.',
      },
    },
    balanced: {
      hours: 1606,
      price_min: 56210.0,
      price_max: 64641.5,
      discovery: 2.4,
      design_min: 11242.0,
      design_max: 12928.5,
      accuracy: 85.0,
      people_in_team: 5,
      weeks_min: 10,
      weeks_max: 12,
      team: [
        {
          name: 'Project Manager',
          amount: 1,
        },
        {
          name: 'Frontend Developer',
          amount: 1,
        },
        {
          name: 'Backend Developer',
          amount: 1,
        },
        {
          name: 'QA Engineer',
          amount: 1,
        },
        {
          name: 'UI/UX Designer',
          amount: 1,
        },
      ],
      consultation_minutes: 45,
      system_discovery_days_min: 10,
      system_discovery_days_max: 15,
      design_days_min: 40,
      design_days_max: 48,
      system_development_days_min: 50,
      system_development_days_max: 60,
      system_improvement_days_min: 20,
      system_improvement_days_max: 40,
      key_features: {
        feature_1:
          'Automated billing and subscription management for seamless recurring payments.',
        feature_2:
          'Tools for creating, managing, and analyzing marketing campaigns across multiple channels.',
        feature_3:
          'Comprehensive product catalog with inventory tracking, enabling real-time updates.',
        feature_4:
          'User-friendly admin dashboard for easy access to analytics and content management.',
        feature_5:
          'Streamlined order processing and fulfillment tracking with status updates.',
        feature_6:
          'Secure payment processing options, including credit cards, PayPal, and digital wallets.',
      },
    },
    advanced: {
      hours: 2615,
      price_min: 91525.0,
      price_max: 105253.5,
      discovery: 2.4,
      design_min: 11242.0,
      design_max: 12928.5,
      accuracy: 90.0,
      people_in_team: 7,
      weeks_min: 11,
      weeks_max: 13,
      team: [
        {
          name: 'Project Manager',
          amount: 1,
        },
        {
          name: 'Business Analyst',
          amount: 1,
        },
        {
          name: 'Frontend Developer',
          amount: 1,
        },
        {
          name: 'Backend Developer',
          amount: 2,
        },
        {
          name: 'QA Engineer',
          amount: 1,
        },
        {
          name: 'UI/UX Designer',
          amount: 1,
        },
      ],
      consultation_minutes: 45,
      system_discovery_days_min: 10,
      system_discovery_days_max: 15,
      design_days_min: 40,
      design_days_max: 48,
      system_development_days_min: 54,
      system_development_days_max: 65,
      system_improvement_days_min: 33,
      system_improvement_days_max: 65,
      key_features: {
        feature_1:
          'Automated billing and subscription management for seamless recurring payments.',
        feature_2:
          'Tools for creating, managing, and analyzing marketing campaigns across multiple channels.',
        feature_3:
          'Comprehensive product catalog with inventory tracking, enabling real-time updates.',
        feature_4:
          'User-friendly admin dashboard for easy access to analytics and content management.',
        feature_5:
          'Streamlined order processing and fulfillment tracking with status updates.',
        feature_6:
          'Secure payment processing options, including credit cards, PayPal, and digital wallets.',
        feature_7:
          'Customer feedback system for submitting reviews and ratings to enhance product quality.',
        feature_8:
          'Integration capabilities with third-party services for extended functionality and data synchronization.',
      },
    },
  },
};
